import { SituacaoEmailSecretaria } from 'src/tipos'

export type VariacaoEmailSecretaria = 'ok' | 'erro' | 'neutro'

export const rotuloEmailSecretaria = (
  situacao?: SituacaoEmailSecretaria,
  pagamentoConfirmado?: boolean
): { texto: string; variacao: VariacaoEmailSecretaria } => {
  if (situacao === SituacaoEmailSecretaria.Enviado) {
    return { texto: 'Enviado', variacao: 'ok' }
  }

  if (situacao === SituacaoEmailSecretaria.Falhou) {
    return { texto: 'Falhou, reenviar', variacao: 'erro' }
  }

  if (pagamentoConfirmado) {
    return { texto: 'Antes da notificação', variacao: 'neutro' }
  }

  return { texto: 'Envia após o pagamento', variacao: 'neutro' }
}

export const podeReenviarEmailSecretaria = (
  situacao?: SituacaoEmailSecretaria,
  pagamentoConfirmado?: boolean,
  incluirJaEnviado = true
): boolean => {
  if (!pagamentoConfirmado) return false
  if (situacao === SituacaoEmailSecretaria.Falhou) return true
  return incluirJaEnviado && situacao === SituacaoEmailSecretaria.Enviado
}
